import { Location, LocationStrategy } from '@angular/common';
import { AfterContentChecked, AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { document } from 'ngx-bootstrap/utils';
import { Subscription } from 'rxjs';
import { PlacardConfirmationSession, UploadedImageInformation } from '../../api/models/placardConfirmationSession';
import { SessionRequest } from '../../api/models/SessionRequest';
import { SessionResponse } from '../../api/models/SessionResponse';
import { ApiErrorCode, HTML_HEADER, RouteURLConstants, ServiceURLConstants } from '../../constants/upplm.constants';
import { UPPLM_TRANSLATIONS } from '../../constants/upplm.constants.translations';
import { IChooseDateFormObj } from '../../interface/generic.object.interface';
import { Address, PlacardConfirmationInfo, PlacardConfirmationStatusRequest, PlacardConfirmationStatusResponse } from '../../interface/upplm.placardconfirmation';
import { TranslateDataPipe } from '../../pipes/translation.pipe';
import { UpplmApiService } from '../../services/upplm.api.services';
import { UpsCommonService } from '../../services/upplm.common.service';
import { UpplmSessionService } from '../../services/upplm.session.service';
import { BreadcrumbItem } from '../commonComponent/ups-breadcrumb/breadcrumbItem';
import { UpsDialogComponent } from '../commonComponent/ups-dialog/ups-dialog.component';
import { UpsFileUploadComponent } from '../commonComponent/ups-fileUpload/ups-fileUpload.component';

@Component({
    selector: 'placardVerification',
    template: require('./placardVerification.component.html')
})

export class PlacardVerificationComponent implements AfterViewInit, AfterContentChecked, OnInit {
    //--------------------------------------------------
    //variables to configure the control ups-fileUpload
    //--------------------------------------------------
    public validFileTypes = [
        'image/bmp',
        'image/gif',
        'image/jpeg',
        'image/png'
    ];
    //this variable is to load the list of files in component ups-fileUpload
    public getfile: Array<any> = [];
    // to call the functions in the component ups-fileUpload
    @ViewChild('fileUpload', { static: false }) fileUploadComponent: UpsFileUploadComponent;
    //--------------------------------------------------
    //variables to load files and event object ups-fileUpload
    //--------------------------------------------------
    formData: FormData = new FormData();
    filesUpload: Array<any> = [];
    files: Array<any> = [];
    status: string = '';
    //--------------------------------------------------
    //commun
    //--------------------------------------------------
    placardID: string = '';
    companyName: string = "";
    addressInformation: Address;
    placardDisplayed: boolean = false;
    placardImage: UploadedImageInformation;
    pickupStartDate: string = '';
    cfsd: string = '';
    paramsUrl: string = '?loc=en_US&placardid=';
    Errors: any = [];
    validateControls: boolean = false;
    public isConfirmed: boolean = false;
    public isLoading: boolean = false;
    public comesFromReview: boolean = false;
    public backBrowserPage: string = '';
    public isInitialLoading: boolean = true;
    private _placardConfirmationStatusRequest: PlacardConfirmationStatusRequest;
    private _placardConfirmationStatusResponse: PlacardConfirmationStatusResponse;
    sessionData: SessionResponse;
    //--------------------------------------------------
    //variables for component control modals
    //--------------------------------------------------
    @ViewChild('sessionnTimeOut', { static: false }) sessionnTimeOut: UpsDialogComponent;
    @ViewChild('messages', { static: false }) errorMessagesServer: UpsDialogComponent;
    @ViewChild('awesomeDP', { static: false }) awesomeDP;
    @ViewChild('awesomeDPCFSD', { static: false }) awesomeDPCFSD;
    public messagesErrorServer: string = '';
    public chooseDatefOrmObj: IChooseDateFormObj;
    public chooseDatefOrmObjCFSD: IChooseDateFormObj;
    public sessionnTimeOutTitle: string = '';
    //--------------------------------------------------
    //variables to configure the control calendar
    //--------------------------------------------------
    disabledDatesValue: Array<Date> = [];
    minValue: any;
    maxValue: any;
    private _control: FormControl = new FormControl();
    public form = new FormGroup({});
    //--------------------------------------------------
    //validation
    //--------------------------------------------------
    public eventValidation: string = '';
    public image: boolean = false;
    public display: boolean = false;
    public calendar: boolean = false;
    public calendarCFSD: boolean = false;
    calendarValidateDate: boolean = false;
    calendarCFSDValidateDate: boolean = false;
    messageValidDate: string = '';
    messageCFSDValidDate: string = '';
    //--------------------------------------------------
    //Variables for Page Title and Header
    //--------------------------------------------------
    pageTitleText = '';
    ManageUPSText = '';
    subscription: Subscription;
    removeFileMsg: string = 'Remove File';
    public breadCrumbItems: BreadcrumbItem[] = [];

    constructor(private router: Router,
        public _activatedRoute: ActivatedRoute,
        private cdref: ChangeDetectorRef,
        private location: Location,
        private locationStrategy: LocationStrategy,
        private _apiService: UpplmApiService,
        private _commonService: UpsCommonService,
        private _sessionService: UpplmSessionService,
        private _translateData: TranslateDataPipe) {
        this.chooseDatefOrmObj = new IChooseDateFormObj();
        this.chooseDatefOrmObjCFSD = new IChooseDateFormObj();
    }

    ngOnInit(): void {
        this.disabledBrowser();
        this.pageTitleText = this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle');
        this.ManageUPSText = HTML_HEADER.MANAGE_UPPLOCATION_HEADER;
        this.removeFileMsg = this._translateData.transform('upplm.placardverification.removefile');
        this.sessionnTimeOutTitle = this._translateData.transform('upplm.common.sessiontimedouttitle');
        this.createBreadCrumb();
    }

    ngAfterViewInit() {
        setTimeout(() => {
            var d = new Date();
            let datestring = (d.getMonth() + 1) + "/" + d.getDate() + "/" + d.getFullYear();
            this.chooseDatefOrmObj.DpVal = new Date(datestring);
            this.chooseDatefOrmObjCFSD.DpVal = new Date(datestring);
            this.isInitialLoading = true;
            this.placardID = this._activatedRoute.snapshot.queryParamMap.get('placardid');
            if (this.placardID === null) {
                this.placardID = this._commonService.getUrlParameter("placardid");
            }
            this.placardID = this.placardID.toUpperCase();
            this.sessionData = this._sessionService.sessionData;

            let request = this.createSessionRequest('', false);
            let requestImg: any;
            if (request.placardConfirmation) {
                if (request.placardConfirmation.placardImage) {
                    requestImg = request.placardConfirmation.placardImage;
                    delete request.placardConfirmation.placardImage;
                }
            }

            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess && response.key) {
                    this.validateAndSetPlacardID(response.placardID);
                    this.sessionData = response;

                    if (response.placardConfirmation !== null) {
                        response.placardConfirmation.placardImage = requestImg;
                    }
                    this._sessionService.mapSessionResponse(response);
                    this.comesFromReview = this.sessionData.comesFromReview;
                    this.backBrowserPage = this.sessionData.backBrowserPage;
                    this.processFromReviewOrFromBackBrowserPage();
                    this.isInitialLoading = false;
                }
            });

        }, 1000);
    }

    processFromReviewOrFromBackBrowserPage() {
        if (this.comesFromReview || (this.backBrowserPage !== '' && this.backBrowserPage !== undefined && this.backBrowserPage !== null)) {
            if (this.sessionData.placardConfirmation.placardImage !== null && this.sessionData.placardConfirmation.placardImage !== undefined) {
                this.setImageFile();
            }
            this.validateBackBrowserPageAndGetPlacardVerification();
        } else {
            this.getPlacardVerification(false);
        }
    }

    validateBackBrowserPageAndGetPlacardVerification() {
        if (this.backBrowserPage !== null && (typeof this.backBrowserPage !== 'undefined')) {
            this.getPlacardVerification(true);
        } else {
            this.getPlacardVerification(this.comesFromReview);
        }

    }

    validateAndSetPlacardID(placardID: string) {
        if (this.placardID === null) {
            this.placardID = placardID;
        }
    }

    setImageFile() {
        if (this.sessionData.placardConfirmation.placardImage.name !== '') {
            let file = {
                fileName: this.sessionData.placardConfirmation.placardImage.fullName,
                fileContent: this.sessionData.placardConfirmation.placardImage.contents
            };
            this.getfile.push(file);
        }
    }

    ngAfterContentChecked() {
        this.cdref.detectChanges();
    }

    bindDataFromSession(data: PlacardConfirmationSession) {
        this.placardID = data.placardId;
        this.placardDisplayed = data.placardDisplayed;
        let dateValue = new Date(data.pickupStartDate);
        dateValue.setMinutes(dateValue.getMinutes() + dateValue.getTimezoneOffset());
        this.chooseDatefOrmObj.DpVal = dateValue;
        let dateValueCFSD = data.customerFacingStartDate && data.customerFacingStartDate.trim().length > 0 ? new Date(data.customerFacingStartDate) : this.getNextBusinessDay(dateValue);
        dateValueCFSD.setMinutes(dateValueCFSD.getMinutes() + dateValueCFSD.getTimezoneOffset())
        this.chooseDatefOrmObjCFSD.DpVal = dateValueCFSD;
    }

    getNextBusinessDay(current: Date): Date {
        let objCuerretDate = new Date(current.getFullYear(), current.getMonth(), current.getDate());
        objCuerretDate.setDate(objCuerretDate.getDate() + 1);
        let foundAsDisbled = this.disabledDatesValue.filter(x => x.toDateString() === current.toDateString());
        if (foundAsDisbled.length !== 0) {
            return this.getNextBusinessDay(objCuerretDate);
        } else {
            return objCuerretDate;
        }
    }

    callCalendar(open: boolean, control: string) {
        if (this.Errors.length > 0) {
            this.Errors = this.remove(this.Errors, 'pickupStartDate');
            this.Errors = this.remove(this.Errors, 'cfsd');
        }

        this.calendar = false;
        this.calendarCFSD = false;
        var dateMin = new Date(this.minValue);
        dateMin.setDate(dateMin.getDate() - 1);
        var dateMax = new Date(this.maxValue);
        dateMax.setDate(dateMax.getDate() + 1);
        if (control === "psd") {
            this.getValidationDatePicker('psd');
            this.awesomeDP.config.showCloseBtn = true;
            this.awesomeDP.config.showFirstAvailableBtn = true;
            this.awesomeDP.config.showClearBtn = true;
            this.awesomeDP.config.isInline = true;
            this.awesomeDP.setConfig({
                minDate: dateMin,
                maxDate: dateMax,
                disabledDates: this.disabledDatesValue
            });
            if (open) {
                this.awesomeDP.toggle();
            }
            this.chooseDatefOrmObj.IsShown = true;
            this.chooseDatefOrmObj.DateSelected = false;
            this.chooseDatefOrmObj.IsModalFlow = true;
            this.chooseDatefOrmObj.showSelfEnrollOA = true;
        }
        else {
            var dateMin = new Date(this.awesomeDP.getDateStr());
            dateMin.setDate(dateMin.getDate() - 1);
            this.getValidationDatePicker('cfsd');
            this.awesomeDPCFSD.config.showCloseBtn = true;
            this.awesomeDPCFSD.config.showFirstAvailableBtn = true;
            this.awesomeDPCFSD.config.showClearBtn = true;
            this.awesomeDPCFSD.config.isInline = true;
            this.awesomeDPCFSD.setConfig({
                minDate: dateMin,
                maxDate: dateMax,
                disabledDates: this.disabledDatesValue
            });
            if (open) {
                this.awesomeDPCFSD.toggle();
            }
            this.chooseDatefOrmObjCFSD.IsShown = true;
            this.chooseDatefOrmObjCFSD.DateSelected = false;
            this.chooseDatefOrmObjCFSD.IsModalFlow = true;
            this.chooseDatefOrmObjCFSD.showSelfEnrollOA = true;
        }
    }

    //message error to validate file type
    errorMessageFileType(event: any) {
        this.eventValidation = event;
        if (this.eventValidation === 'successFileMax' || this.eventValidation === 'error') {
            this.Errors = this.remove(this.Errors, 'errorFileMax');
            if (this.eventValidation === 'error') {
                this.fileUploadComponent.clear();
                this.filesUpload = [];
            }
        } else if (this.eventValidation === 'succesType' || this.eventValidation === 'errorFileMax') {
            this.Errors = this.remove(this.Errors, 'error');
            if (this.eventValidation === 'errorFileMax') {
                this.fileUploadComponent.clear();
                this.filesUpload = [];
            }
        }
    }

    errorMessageFileTypeNext() {
        let event = this.eventValidation;
        let objeMessage = Object();

        if (!this.comesFromReview) {
            if (event === '' || event === "errorFileRequired" || (this.status === 'delete' && event !== 'error') || (this.status === 'delete' && event !== 'errorFileMax')) {
                if (this.Errors.filter(el => el.id === 'errorFileRequired').length === 1) {
                    this.Errors = this.remove(this.Errors, 'errorFileRequired');
                }
                objeMessage.id = 'errorFileRequired';
                objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.photoisrequired');
                objeMessage.value = 2;
                this.Errors.push(objeMessage);
                this.validateControls = true;
                this.eventValidation = 'errorFileRequired';

            } else {
                this.Errors = this.remove(this.Errors, 'errorFileRequired');
                this.validateControls = false;
            }
        }

        if (event === 'errorFileMax') {
            this.handleFileErrorByEvent('errorFileMax', 'error', 'errorFileMax', 2, true, this._translateData.transform('upplm.placardverification.fileistoolarge'));
        } else {
            this.removeSuccessFromErrors(event);
        }
        if (event === 'error') {
            this.handleFileErrorByEvent('error', 'errorFileMax', 'error', 3, true, this._translateData.transform('upplm.placardverification.filetypeinvalid'));
        } else {
            this.removeSuccessFromErrors(event);
        }
    }

    removeSuccessFromErrors(event: string) {
        if (this.Errors.length > 0 && event === event) {
            this.Errors = this.remove(this.Errors, 'error');
            this.Errors = this.remove(this.Errors, 'errorFileMax');
            this.validateControls = false;
        }
    }

    handleFileErrorByEvent(event: string, errorToRemove: string, errorId: string, errorValue: number, validateControls: boolean, errorMessage: string) {
        let objeMessage = Object();

        let val = this.Errors.filter(el => el.id === event);
        if (val.length > 0) {
            this.Errors = this.remove(this.Errors, errorToRemove);
            this.validateControls = validateControls;
        }
        else {
            objeMessage.id = errorId;
            objeMessage.errorMessage = errorMessage;
            objeMessage.value = errorValue;
            this.Errors.push(objeMessage);
            this.validateControls = validateControls;
            this.Errors = this.remove(this.Errors, errorToRemove);
        }
    }

    public fileList($event: any) {
        this.filesUpload = $event.file;
        this.status = $event.status;
    }

    getPlacardVerification(sessionDataEdit: boolean) {
        if (this.placardID === "") {
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
        }
        else {
            let url = this._commonService.createURL(ServiceURLConstants.GET_PLACARD_CONFIRMATION_STATUS, ApiErrorCode.GET_PLACARD_VERIFICATION);
            this._apiService.PostServiceAPI(url, this.placardID).subscribe((response: PlacardConfirmationStatusResponse) => {

                if (response.errors !== null) {
                    if (response.errors[0].message !== '' || response.errors[0].message !== null) {
                        this.messagesErrorServer = this._translateData.transform('upplm.common.serviceerror');
                        this.openModel();
                        return;
                    }
                }
                let datesValues: any = [];
                if (response.placardConfirmationInfo !== null) {
                    response.placardConfirmationInfo.nonBusinessDays.forEach(element => {
                        datesValues.push(new Date(element));
                    });
                }
                this.setDisableDatesValues(datesValues, response.placardConfirmationInfo);
                this.setMaxAndMinDates(response.placardConfirmationInfo);
                this.callCalendar(false, 'psd');
                this.callCalendar(false, 'cfsd');
                this.bindConfirmationDataFromSessionOrResponse(sessionDataEdit, response);
                this.redirectOrContinueConfirmationFlow(sessionDataEdit, response);
            });
        }
    }

    setDisableDatesValues(datesValues: any[], confirmationInfo: PlacardConfirmationInfo) {
        if (confirmationInfo !== null && (typeof confirmationInfo !== 'undefined')) {
            this.disabledDatesValue = datesValues;
        } else {
            this.disabledDatesValue = [];
        }
    }

    setMaxAndMinDates(confirmationInfo: PlacardConfirmationInfo) {
        if (confirmationInfo !== null && (typeof confirmationInfo !== 'undefined')) {
            this.minValue = confirmationInfo.minDate;
            this.maxValue = confirmationInfo.maxDate;
        } else {
            this.minValue = [];
            this.maxValue = [];
        }
    }

    bindConfirmationDataFromSessionOrResponse(sessionDataEdit: boolean, response) {
        if (sessionDataEdit) {
            this.bindDataFromSession(this.sessionData.placardConfirmation);
        } else {
            this.setDateCalendarDate(response.placardConfirmationInfo);
        }
    }

    setDateCalendarDate(response: PlacardConfirmationInfo) {
        if (response !== null && (typeof response !== 'undefined')) {
            this.chooseDatefOrmObj.DpVal = new Date(response.minDate);
            this.chooseDatefOrmObjCFSD.DpVal = new Date(response.minDate);
        } else {
            this.chooseDatefOrmObj.DpVal = this.awesomeDP.getDate();
            this.chooseDatefOrmObjCFSD.DpVal = this.awesomeDPCFSD.getDate();
        }
    }

    redirectOrContinueConfirmationFlow(sessionDataEdit: boolean, response: PlacardConfirmationStatusResponse) {
        if (response.errors) {
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
        }
        else {
            this.placardID = response.placardId;
            this.isConfirmed = response.confirmed;
            this.editInSession(sessionDataEdit, response);
        }
    }

    editInSession(sessionDataEdit: boolean, response: PlacardConfirmationStatusResponse) {
        if (sessionDataEdit) {
            this._placardConfirmationStatusResponse = response;
            this.companyName = response.companyName;
            this.addressInformation = { ...response.placardConfirmationInfo.address };
        } else {
            this.redirectToConfirmedOrStayInConfirmationFlow(response);
        }
    }

    redirectToConfirmedOrStayInConfirmationFlow(response: PlacardConfirmationStatusResponse) {
        if (this.isConfirmed) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_CONFIRMED_ROUTE + this.paramsUrl.concat(this.placardID), false);
        }
        else {
            this._placardConfirmationStatusResponse = response;
            this.companyName = response.companyName;
            this.addressInformation = { ...response.placardConfirmationInfo.address };
        }
    }

    private getValidationDatePicker(control: string): boolean {
        if (control === "psd") {
            this.awesomeDP.isValidRangeStr(document.getElementById('pickupStartDate').value)
        }
        else {
            this.awesomeDPCFSD.isValidRangeStr(document.getElementById('cfsd').value)
        }
        return true;
    }

    public focusoutHandler(value: any, control: string) {
        this.validationCalendarFormat(value.target.value, control);
    }

    public onChange(value: any, control: string) {
        this.validationCalendarFormat(value, control);
    }

    private validationCalendarFormat(value: any, control: string) {
        let psdDate: Date = new Date(this.awesomeDP.getDateStr());
        let cfsdDate: Date = new Date(this.awesomeDPCFSD.getDateStr());

        if (control === 'psd') {
            if (value !== '') {
                this.validatePSD(value);
                this.validatePSDRange(value);
            } else {
                this.calendarValidateDate = false;
            }
        } else {
            if (value !== '') {
                this.validateCFSD(value);
                this.validateCFSDRange(value);
            } else {
                this.calendarCFSDValidateDate = false;
            }
        }
        if (psdDate > cfsdDate) {
            this.calendarValidateDate = true;
            this.messageValidDate = this._translateData.transform('upplm.placardverification.psdpasttocfsd');
        }
    }

    validatePSDRange(value: any) {
        if (!this.awesomeDP.isValidRangeStr(value)) {
            this.calendarValidateDate = true;
            this.messageValidDate = this._translateData.transform('upplm.placardverification.dateinvalidrange');
        } else {
            this.calendarValidateDate = false;
        }
    }

    validatePSD(value: any) {
        if (!this.awesomeDP.isValid(value)) {
            this.calendarValidateDate = true;
            this.messageValidDate = this._translateData.transform('upplm.placardverification.dateincorrectformat');
        }
        else {
            this.calendarValidateDate = false;
        }
    }

    validateCFSD(value: any) {
        if (!this.awesomeDPCFSD.isValid(value)) {
            this.calendarCFSDValidateDate = true;
            this.messageCFSDValidDate = this._translateData.transform('upplm.placardverification.dateincorrectformat');;
        } else {
            this.calendarCFSDValidateDate = false;
        }
    }

    validateCFSDRange(value: any) {
        if (!this.awesomeDP.isValidRangeStr(value)) {
            this.calendarCFSDValidateDate = true;
            this.messageCFSDValidDate = this._translateData.transform('upplm.placardverification.dateinvalidrange');
        } else {
            this.calendarCFSDValidateDate = false;
        }
    }

    activatePlacardDisplayed(event: Event) {
        this.placardDisplayed = (<HTMLInputElement>event.target).checked;
        if (this.placardDisplayed) {
            if (this.Errors.length > 0) {
                this.Errors = this.remove(this.Errors, 'errorRadio');
            }
            this.display = false;
        }
    }

    public next() {
        if ('Location' === this.sessionData.backBrowserPage) {
            this.loadDataSave();
        }

        if (!this.validationControls() && !this.calendarValidateDate && !this.calendarCFSDValidateDate && this.Errors.length === 0) {
            if (this.filesUpload.length > 0) {
                this.fileUpload();
            } else {
                if (this.sessionData.comesFromReview) {
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE + this.paramsUrl.concat(this.placardID), true);
                } else {
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_LOCATION_ROUTE, true);
                }
            }
        }
    }

    public save() {
        this.loadDataSave();
        this.next();
    }

    public cancel() {
        if (this.sessionData.comesFromReview) {
            this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE, false);
        }
        else {
            this.cancelGoDashboardPage();
        }
    }

    loadDataSave() {
        this.placardID = this.sessionData.placardConfirmation.placardId;
        if (this.status === 'delete' && this.filesUpload.length === 0) {
            this.placardImage = null;
        } else {
            this.placardImage = this.sessionData.placardConfirmation.placardImage;
        }
        this.placardDisplayed = this.sessionData.placardConfirmation.placardDisplayed;
        this.pickupStartDate = this.sessionData.placardConfirmation.pickupStartDate;
        this.cfsd = this.sessionData.placardConfirmation.customerFacingStartDate;
    }

    validationControls(): boolean {

        let result: boolean = false;
        this.image = false;
        this.display = false;
        this.calendar = false;
        this.calendarCFSD = false;

        this.validatePickupStartDate();
        this.validateCustomerFacingStartDate();
        this.validatePickupStartDateCalendarControl();
        this.validateCustomFacingStartDateCalendarControl();

        this.validateMustConfirm();
        this.errorMessageFileTypeNext();
        if (this.validateControls) {
            this.image = true;
        }
        this.Errors.sort((a, b) => (a.value > b.value) ? 1 : -1);
        result = this.getValidatonResult();
        return result;
    }

    validateCustomFacingStartDateCalendarControl() {
        if (this.calendarCFSDValidateDate) {
            if (this.Errors.length > 0) {
                let val = this.Errors.filter(el => el.id === 'cfsd');
                if (val.length > 0) {
                    this.calendarCFSDValidateDate = true;
                }
                else {

                    let objeMessage = Object();
                    objeMessage.id = 'cfsd';
                    objeMessage.errorMessage = this.messageCFSDValidDate;
                    objeMessage.value = 4;
                    this.Errors.push(objeMessage);
                    this.calendarCFSDValidateDate = true;
                }
            }
            else {
                let objeMessage = Object();
                objeMessage.id = 'cfsd';
                objeMessage.errorMessage = this.messageCFSDValidDate;
                objeMessage.value = 4;
                this.Errors.push(objeMessage);
                this.calendarCFSDValidateDate = true;
            }
        }
        else {
            if (this.Errors.length > 0) {
                if (this.calendar === false) {
                    this.Errors = this.remove(this.Errors, 'cfsd');
                }
            }
            this.calendarCFSDValidateDate = false;
        }
    }

    validatePickupStartDateCalendarControl() {
        if (this.calendarValidateDate) {
            if (this.Errors.length > 0) {
                let val = this.Errors.filter(el => el.id === 'pickupStartDate');
                if (val.length > 0) {
                    this.calendarValidateDate = true;
                }
                else {
                    let objeMessage = Object();
                    objeMessage.id = 'pickupStartDate';
                    objeMessage.errorMessage = this.messageValidDate;
                    objeMessage.value = 4;
                    this.Errors.push(objeMessage);
                    this.calendarValidateDate = true;
                }
            }
            else {
                let objeMessage = Object();
                objeMessage.id = 'pickupStartDate';
                objeMessage.errorMessage = this.messageValidDate;
                objeMessage.value = 4;
                this.Errors.push(objeMessage);
                this.calendarValidateDate = true;
            }
        }
        else {
            if (this.Errors.length > 0) {
                if (this.calendar === false) {
                    this.Errors = this.remove(this.Errors, 'pickupStartDate');
                }
            }
            this.calendarValidateDate = false;
        }
    }

    validateCustomerFacingStartDate() {
        if (document.getElementById('cfsd').value === '') {
            this.messageCFSDValidDate = this._translateData.transform('upplm.placardverification.cfsdisrequired');
            this.calendarCFSDValidateDate = true;
            if (this.Errors.length > 0) {
                let val = this.Errors.filter(el => el.id === 'cfsd');
                if (val.length > 0) {
                    val[0].errorMessage = this._translateData.transform('upplm.placardverification.cfsdisrequired');
                    this.calendarCFSD = true;
                }
                else {
                    let objeMessage = Object();
                    objeMessage.id = 'cfsd';
                    objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.cfsdisrequired');
                    objeMessage.value = 4;
                    this.Errors.push(objeMessage);
                    this.calendarCFSD = true;
                }
            }
            else {
                let objeMessage = Object();
                objeMessage.id = 'cfsd';
                objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.cfsdisrequired');
                objeMessage.value = 4;
                this.Errors.push(objeMessage);
                this.calendarCFSD = true;
            }
        }
        else {
            let value = document.getElementById('cfsd').value;
            this.validationCalendarFormat(value, 'cfsd');
            if (this.Errors.length > 0) {
                this.Errors = this.remove(this.Errors, 'cfsd');
            }
            this.calendarCFSD = false;
        }
    }

    validatePickupStartDate() {
        if (document.getElementById('pickupStartDate').value === '') {
            this.messageValidDate = this._translateData.transform('upplm.placardverification.psdisrequired');
            this.calendarValidateDate = true;
            if (this.Errors.length > 0) {
                let val = this.Errors.filter(el => el.id === 'pickupStartDate');
                if (val.length > 0) {
                    val[0].errorMessage = this._translateData.transform('upplm.placardverification.psdisrequired');
                    this.calendar = true;
                } else {
                    let objeMessage = Object();
                    objeMessage.id = 'pickupStartDate';
                    objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.psdisrequired');
                    objeMessage.value = 4;
                    this.Errors.push(objeMessage);
                    this.calendar = true;
                }
            } else {
                let objeMessage = Object();
                objeMessage.id = 'pickupStartDate';
                objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.psdisrequired');
                objeMessage.value = 4;
                this.Errors.push(objeMessage);
                this.calendar = true;
            }
        } else {
            let value = document.getElementById('pickupStartDate').value;
            this.validationCalendarFormat(value, 'psd');
            if (this.Errors.length > 0) {
                this.Errors = this.remove(this.Errors, 'pickupStartDate');
            }
            this.calendar = false;
        }
    }

    validateMustConfirm() {
        if (!this.placardDisplayed) {
            if (this.Errors.length > 0) {
                this.validateConfirmPlacardToggle();
            } else {
                let objeMessage = Object();
                objeMessage.id = 'errorRadio';
                objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.mustconfirmplacarddisplayed');
                objeMessage.value = 1;
                this.Errors.push(objeMessage);
                this.display = true;
            }
        } else {
            if (this.Errors.length > 0) {
                this.Errors = this.remove(this.Errors, 'errorRadio');
            }
            this.display = false;
        }
    }

    validateConfirmPlacardToggle() {
        let val = this.Errors.filter(el => el.id === 'errorRadio');
        if (val.length > 0) {
            this.display = true;
        }
        else {
            let objeMessage = Object();
            objeMessage.id = 'errorRadio';
            objeMessage.errorMessage = this._translateData.transform('upplm.placardverification.mustconfirmplacarddisplayed');
            objeMessage.value = 1;
            this.Errors.push(objeMessage);
            this.display = true;
        }
    }

    getValidatonResult(): boolean {
        if (!this.comesFromReview) {
            return this.resultFromErrorsLenght();
        }
        else {
            return this.getControlValidationResult();
        }
    }

    getControlValidationResult(): boolean {
        if (this.getValidationAgainstImage() && this.calendarValidateDate && this.calendarCFSDValidateDate) {
            return true;
        } else if (this.getValidationAgainstImage() && this.calendarValidateDate === false && this.calendarCFSDValidateDate === false) {
            return true;
        } else if (this.getValidationAgainstImage() === false && this.calendarValidateDate && this.calendarCFSDValidateDate) {
            return true;
        } else {
            return false
        }
    }

    getValidationAgainstImage(): boolean {
        if (this.getInputResults() && this.image) {
            return true;
        } else if (this.getInputResults() === false && this.image) {
            return false;
        } else if (this.getInputResults() === false && this.image === false) {
            return false;
        } else {
            return true;
        }
    }

    getInputResults(): boolean {
        if (this.calendar && this.calendarCFSD && this.display) {
            return true;
        }
        if (!this.calendar && !this.calendarCFSD && this.display) {
            return true;
        }
        if (this.calendar && this.calendarCFSD && !this.display) {
            return true;
        }
        return false;
    }

    resultFromErrorsLenght(): boolean {
        if (this.Errors.length > 0) {
            return true;
        }
        return false;
    }

    remove(array: any, element: any) {
        return array.filter(el => el.id !== element);
    }

    focusInput(item: any) {
        document.getElementById(item.id).focus();
    }

    fileUpload() {

        if (this.filesUpload.length > 0) {
            for (let i = 0; i < this.filesUpload.length; i++) {
                const file = this.filesUpload[i];
                let attachment = {
                    fileName: file.fileName
                }
                this.formData.append('fileUPS', file.filesEvent, file.fileName);
            }

            this.formData.append('placardId', this.placardID);
            this._apiService.PostUploadServiceAPI(this._commonService.createURL(ServiceURLConstants.CREATE_PLACARD_CONFIRMATION, ApiErrorCode.CREATE_PLACARD_CONFIRMATION), this.formData).subscribe((response: any) => {
                this.placardImage = response.placardImage;
                this.placardImage.fullName = this.filesUpload[0].fileName;
                this.placardImage.name = this.filesUpload[0].fileName.substring(0, this.filesUpload[0].fileName.lastIndexOf('.'));
                this.placardImage.extension = this.filesUpload[0].fileName.split('.').pop();
                this.placardID = response.placardId;
                this.formData = new FormData();
                if (this.sessionData.comesFromReview) {
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_APPROVE_ROUTE + this.paramsUrl.concat(this.placardID), true);
                } else {
                    this.validateSessionAndNavigate(RouteURLConstants.UPPLM_VIEW_PLACARD_LOCATION_ROUTE, true);
                }

            });
        }
    }

    createSessionRequest(target: string, update?: boolean): SessionRequest {

        let request: SessionRequest = new SessionRequest();
        request.placardID = this.placardID;
        request.key = this.sessionData.key;
        request.placardStatus = this.sessionData.placardStatus;
        request.comesFromReview = this.sessionData.comesFromReview;
        request.backBrowserPage = this.sessionData.backBrowserPage;
        request.locationDetails = this.sessionData.locationDetails;
        request.contactDetails = this.sessionData.contactDetails;
        request.placardDetails = this.sessionData.placardDetails;
        request.pickupDetails = this.sessionData.pickupDetails;
        request.notificationDetails = this.sessionData.notificationDetails;
        request.placardLocation = this.sessionData.placardLocation;
        request.lastTimeSessionReqired = new Date().toString();
        if (update) {
            let data: PlacardConfirmationSession = new PlacardConfirmationSession();
            if (target !== RouteURLConstants.UPPLM_VIEW_PLACARD_CONFIRMED_ROUTE) {
                data.placardId = this.placardID;
                data.placardImage = this.placardImage;
                data.placardDisplayed = this.placardDisplayed;
                data.pickupStartDate = this.awesomeDP.getDateStr();
                data.customerFacingStartDate = this.awesomeDPCFSD.getDateStr();
                request.placardConfirmation = data;
            }
        }
        else {
            request.placardConfirmation = this.sessionData.placardConfirmation;
        }
        return request;
    }

    validateSessionAndNavigate(target: string, updateSession: boolean) {
        this.isLoading = true;
        if (!this._sessionService.isValidSession()) {
            this.openSessionTimeOutModel();
        } else {
            let request: any = this.createSessionRequest(target, updateSession);
            let requestImg: any;

            if (request.placardConfirmation) {
                if (request.placardConfirmation.placardImage) {
                    requestImg = request.placardConfirmation.placardImage;
                    delete request.placardConfirmation.placardImage;
                }
            }

            this._sessionService.setSessionData(this._commonService.createURL(ServiceURLConstants.SET_UPPLM_SESSION, ApiErrorCode.SET_UPPLM_SESSION), request).subscribe((response: SessionResponse) => {
                if (response.commonResponse.isSuccess) {
                    if (response.placardConfirmation !== null) {
                        response.placardConfirmation.placardImage = requestImg;
                        this._sessionService.mapSessionResponse(response);
                    }
                    this._commonService.url = target;
                    this.router.navigateByUrl(target);
                    this.isLoading = false;
                }
            });
        }
    }

    public openModel() {
        this.errorMessagesServer.open();
    }

    public closeModal() {
        this.errorMessagesServer.close();
    }

    public openSessionTimeOutModel() {
        this.sessionnTimeOut.open();
    }

    public closeSessionTimeOutModal() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            document.location.href = `https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/pagenotfound.page`;
            this.sessionnTimeOut.close();
        });
    }

    cancelGoDashboardPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            this._commonService.url = RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE;
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    cancelGoPlacardVerificationPage() {
        this._sessionService.cleanSessionData(this._commonService.createURL(ServiceURLConstants.CLEAN_SESSION, ApiErrorCode.CLEAN_SESSION)).subscribe((response: any) => {
            this._sessionService.mapSessionResponse(response);
            this._commonService.url = RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE;
            this.router.navigateByUrl(RouteURLConstants.UPPLM_VIEW_DASHBOARD_ROUTE);
        });
    }

    disabledBrowser() {
        history.pushState(null, null, window.location.href);
        this.locationStrategy.onPopState(() => {
            history.pushState(null, null, window.location.href);
        });
    }

    createBreadCrumb() {
        this.breadCrumbItems = [];
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com', this._translateData.transform('upplm.breadcrumb.home')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/services/tracking.page`,
            this._translateData.transform('upplm.breadcrumb.tracking')));
        this.breadCrumbItems.push(new BreadcrumbItem(`https://www.ups.com/${this._commonService.locale_country.toLocaleLowerCase()}/${this._commonService.locale_lang.toLocaleLowerCase()}/tracking/quantum-view.page`,
            this._translateData.transform('upplm.breadcrumb.manageinboundoutbundshipments')));
        this.breadCrumbItems.push(new BreadcrumbItem('https://www.ups.com/upplm/dashboard',
            `${this._translateData.transform('upplm.breadcrumb.manage')} UPS<sup>${String.fromCharCode(174)}</sup> ${UPPLM_TRANSLATIONS.find(x => x.key === 'upplm.common.pickuppoint').default} ${this._translateData.transform('upplm.breadcrumb.locations')}`));
        this.breadCrumbItems.push(new BreadcrumbItem('', this._translateData.transform('upplm.placardlocationdetails.confirmplacardtitle')));
    }
}